var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookLogo = function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8EF",
    d: "M12 .955c6.627 0 12 5.372 12 12 0 5.989-4.388 10.954-10.125 11.854v-8.386h2.796l.532-3.468h-3.328v-2.25c0-.95.465-1.875 1.956-1.875h1.513V5.876s-.16-.027-.421-.063a19 19 0 0 0-1.773-.16q-.245-.01-.492-.01c-2.741 0-4.533 1.66-4.533 4.668v2.644H7.078v3.468h3.047v8.386C4.388 23.909 0 18.944 0 12.955c0-6.628 5.373-12 12-12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .955h24v24H0z"
  })))));
};
export default SvgFacebookLogo;